export default __webpack_public_path__ + "static/media/Rampver Online Topfold.8bf5cd47.webp";